// react
import React from "react";

// third-party
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// application
import Pagination from "../shared/Pagination";

import theme from "../../data/theme";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import { url } from "../../helper";
import BlockLoader from "../blocks/BlockLoader";
import { FormattedMessage } from "react-intl";

const AccountPageOrders = (props) => {
    const customer = useSelector((state) => state.customer);
    const [page, setPage] = useState(1);
    const [orders, setOrders] = useState();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (customer.token) {
            let urlPage = "";
            if (page) {

              urlPage = "&page=" + page;
            //   console.log(urlPage)
            }
            fetch(url + `/api/orders?customer_id=${customer.customerId}&token=${customer.token}` + urlPage)
                .then((response) => response.json())

                .then((res) => {
                  console.log(res)
                    setOrders(res);
                    setLoading(false);
                });
        }
    }, [customer.token, page]);

    const handlePageChange = (page) => {
        setPage(page);
        setLoading(true);
    };

    if (!orders || loading) {
        return <BlockLoader />;
    }
    const ordersList = orders.data.map((order, i) => (
        <tr key={order.id}>
            <td>
                <Link to={`/account/orders/${order.id || 1}`}>{`#${order.id || i}`}</Link>
            </td>
            <td>{new Date(order.created_at).toLocaleDateString()}</td>
            <td>{order.formated_grand_total || "10000դր"}</td>
            <td style={{ color: "#7FAA2A" }}>{order.status || "Հաստատված"}</td>
        </tr>
    ));

    return (
        <div className="card">
            <Helmet>
                <title>{`Order History — ${theme.name}`}</title>
            </Helmet>

            <div className="card-header">
                <h5>
                    <FormattedMessage id="orderhistory" defaultMessage="Պատվերի պատմություն" />
                </h5>
            </div>

            <div className="card-table">
                <div className="table-responsive-sm">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <FormattedMessage id="id" defaultMessage="ID" />{" "}
                                </th>
                                <th>
                                    <FormattedMessage id="date" defaultMessage="Ամսաթիվ" />
                                </th>
                                <th>
                                    <FormattedMessage id="price" defaultMessage="Գին" />
                                </th>
                                <th>
                                    <FormattedMessage id="status" defaultMessage="Ստատուս" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>{ordersList}</tbody>
                    </table>
                </div>
            </div>

            <div className="card-footer">
                {orders.data.length > 0 ? (
                    <Pagination
                      current={page}
                      siblings={10}
                      total={orders.meta.last_page + 1}
                      onPageChange={handlePageChange}
                    />
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};

export default AccountPageOrders;
